"use strict";

function is_imaginary(n) {
  return n.includes("i");
}

module.exports = is_imaginary;
module.exports.default = is_imaginary;
